<template>
    <div class="np-form-user-fields">
        <new-payment-form-field
            field="payment-form-lastName"
            v-model="form.lastName"
            :validation="$v.form.lastName"
            label="Фамилия плательщика*"
            @change-input="checkValid"
        />
        <new-payment-form-field
            field="payment-form-firstName"
            v-model="form.firstName"
            :validation="$v.form.firstName"
            label="Имя плательщика*"
            @change-input="checkValid"
        />
        <new-payment-form-field
            field="payment-form-patronymic"
            v-model="form.patronymic"
            :validation="$v.form.patronymic"
            label="Отчество плательщика"
            @change-input="checkValid"
        />
        <new-payment-form-field
            field="payment-form-birthday"
            v-model="form.birthday"
            :validation="$v.form.birthday"
            label="Дата рождения плательщика*"
            :mask="!isIe() ? 'date' : ''"
            @change-input="checkValid"
        />
        <new-payment-form-field-checkbox
            v-if="formType !== 'hospitals'"
            text="Плательщик является пациентом"
            v-model="form.confirmation"
            field="confirmation"
            :value="form.confirmation"
            @change="checkValid('checkbox')"
        />
        <new-payment-form-field-checkbox
            v-else-if="formType === 'hospitals'"
            text="Оплата за другого пациента"
            v-model="form.paymentForAnotherPatient"
            field="paymentForAnotherPatient"
            :value="form.paymentForAnotherPatient"
            @change="checkValid('checkbox')"
        />
        <div class="np-form-user-fields__patient"
             v-if="!form.confirmation || form.paymentForAnotherPatient">
            <new-payment-form-field
                field="payment-form-patient-lastName"
                v-model="form.patient.lastName"
                :validation="$v.form.patient.lastName"
                label="Фамилия пациента*"
                @change-input="checkValid"
            />
            <new-payment-form-field
                field="payment-form-patient-firstName"
                v-model="form.patient.firstName"
                :validation="$v.form.patient.firstName"
                label="Имя пациента*"
                @change-input="checkValid"
            />
            <new-payment-form-field
                field="payment-form-patient-patronymic"
                v-model="form.patient.patronymic"
                :validation="$v.form.patient.patronymic"
                label="Отчество пациента"
                @change-input="checkValid"
            />
            <new-payment-form-field
                field="payment-form-patient-birthday"
                v-model="form.patient.birthday"
                :validation="$v.form.patient.birthday"
                label="Дата рождения пациента*"
                :mask="!isIe() ? 'date' : ''"
                @change-input="checkValid"
            />
        </div>
    </div>
</template>

<script>
import {required, maxLength, email, requiredIf} from 'vuelidate/lib/validators';
import '@/assets/js/InputmaskAliases';
import NewPaymentFormField from "@/components/new-payment-form/NewPaymentFormField";
import NewPaymentFormFieldCheckbox from "@/components/new-payment-form/NewPaymentFormFieldCheckbox";

const validations = {
    onlyLetters(value) {
        return (/^[A-Za-zА-Яа-яЁё]([A-Za-zА-Яа-яЁё  \-]+)?$/).test(value);
    },
    correctDate(value) {
        return (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/i).test(String(value));
    },
    onlyNumbers(value) {
        return (!/^[0-9]+$/.test(value))
    }
};

export default {
    name: "NewPaymentFormUserFields",
    components: {
        NewPaymentFormField,
        NewPaymentFormFieldCheckbox
    },
    props: {
        userInfo: {
            default: false
        },
        formType: {
            default: 'default'
        }
    },
    data() {
        return {
            form: {
                lastName: '',
                firstName: '',
                patronymic: '',
                birthday: '',
                patient: {
                    firstName: '',
                    lastName: '',
                    patronymic: '',
                    birthday: ''
                },
                confirmation: true,
                paymentForAnotherPatient: false
            },
        }
    },
    validations() {
        return {
            form: {
                lastName: {
                    required,
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                firstName: {
                    required,
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                patronymic: {
                    maxLength: maxLength(50),
                    isCorrect(value) {
                        return value ? validations.onlyLetters(value) : true;
                    }
                },
                birthday: {
                    required,
                    correctDate: () => {
                        return this.$refs['birthday']?.inputmask ? !!this.$refs['birthday'].inputmask.isComplete() : true;
                    },
                    maxLength: maxLength(10),
                    isCorrectDate(value) {
                        let valueReverse = value.split('.').reverse();
                        let currentValueDateTime = new Date(valueReverse[0], valueReverse[1] - 1, valueReverse[2])
                        return value
                            ? this.numValid(value)  &&
                            currentValueDateTime.getTime() > new Date(1800, 0, 1).getTime() &&
                            value.split('.')[2][0] != '0' &&
                            currentValueDateTime <= new Date() : false;
                    },
                },
                patient: {
                    firstName: {
                        required: requiredIf(() => !this.form.confirmation || this.form.paymentForAnotherPatient),
                        maxLength: maxLength(50),
                        isCorrect(value) {
                            return value ? validations.onlyLetters(value) : true;
                        },
                    },
                    lastName: {
                        required: requiredIf(() => !this.form.confirmation || this.form.paymentForAnotherPatient),
                        maxLength: maxLength(50),
                        isCorrect(value) {
                            return value ? validations.onlyLetters(value) : true;
                        }
                    },
                    patronymic: {
                        maxLength: maxLength(50),
                        isCorrect(value) {
                            return value ? validations.onlyLetters(value) : true;
                        }
                    },
                    birthday: {
                        required: requiredIf(() => !this.form.confirmation || this.form.paymentForAnotherPatient),
                        correctDate: () => {
                            return this.$refs['birthday']?.inputmask ? !!this.$refs['birthday'].inputmask.isComplete() : true;
                        },
                        maxLength: maxLength(10),
                        isCorrectDate(value) {
                            if ((this.form.confirmation && !this.form.paymentForAnotherPatient) ||
                                (!this.form.confirmation && this.form.paymentForAnotherPatient))
                                return true
                            else {
                                let valueReverse = value.split('.').reverse();
                                let currentValueDateTime = new Date(valueReverse[0], valueReverse[1] - 1, valueReverse[2])
                                return value
                                    ? this.numValid(value)  &&
                                    currentValueDateTime.getTime() > new Date(1800, 0, 1).getTime() &&
                                    value.split('.')[2][0] != '0' &&
                                    currentValueDateTime <= new Date() : false;
                            }
                        },
                    },
                },
                confirmation: {
                    required
                }
            }
        }
    },
    methods: {
        nextStep() {
            if (!this.$v.$invalid) return this.form;
        },
        checkValid(fieldType) {
            this.$emit('check-valid', {
                step: 2,
                valid: !this.$v.$invalid
            })
            fieldType === 'checkbox' ? this.clearFields() : ''
        },
        isValid(){
            return !this.$v.$invalid
        },
        clearFields() {
            this.form.confirmation || !this.form.paymentForAnotherPatient ?
                this.form.patient = {
                    firstName: '',
                    lastName: '',
                    patronymic: '',
                    birthday: ''
                } : ''
            this.$v.form.patient.$reset()
        },
        isIe() {
            return navigator.userAgent.toLowerCase().includes('rv:11.0') && navigator.userAgent.toLowerCase().includes('trident/7.0')
        },
        numValid(value) {
            let result = true;
            value.split('').forEach(v => {
                if (!(this.isNumeric(v) || v === '.')) {
                    result = false
                }
            })
            return result;
        },
        isNumeric(value) {
            return /^-?\d+$/.test(value);
        }
    },
    mounted() {
        this.userInfo ? this.form = this.userInfo : '';
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mixins-and-vars';

$parent: '.np-form-user-fields';

#{$parent} {
    display: flex;
    flex-direction: column;
    position: relative;
    animation: ezTransformOpacity .2s linear;

    &__patient {
        overflow: hidden;
        animation: easeHeight .35s ease-in;
    }

    @keyframes easeHeight {
        0% {
            max-height: 0px;
            opacity: 0;
        }
        90% {
            max-height: 350px;
        }
        100% {
            max-height: none;
            opacity: 1;
        }
    }
}
</style>
